import { render, staticRenderFns } from "./MailMessage.vue?vue&type=template&id=9761890e&"
import script from "./MailMessage.vue?vue&type=script&lang=js&"
export * from "./MailMessage.vue?vue&type=script&lang=js&"
import style0 from "./MailMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailMessage.vue"
export default component.exports